// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"778807a0","195":"95967fbb","546":"74108957"}[chunkId] + ".chunk.css";
};